import axios from 'axios';

const API_URL = 'https://api.assemblyai.com/v2/transcript';

const getSubs = async (language_code: any, videoUrls: any) => {

    const responsedata = await videoUrls.map(async (item: any, index: any) => {
      try {
        const response = await axios.post(API_URL, {
            audio_url: item.url,
            language_code: language_code,
            audio_start_from : parseInt(item.start),
            audio_end_at: parseInt(item.end)
          }, {
            headers: {
              'Authorization': process.env.REACT_APP_ASSEMBLYAI_API_KEY,
              'Content-Type': 'application/json',
            },
          });
        
          const transcriptId = response.data.id;
          const transcriptUrl = `${API_URL}/${transcriptId}`;
        
          let transcript;
          do {
            const { data } = await axios.get(transcriptUrl, {
              headers: {
                'Authorization': process.env.REACT_APP_ASSEMBLYAI_API_KEY,
              },
            });
            transcript = data;
            if (transcript.status === 'error') {
              console.error('Transcript Error:', transcript.error);
              return transcript.error
              break;
            }
          } while (transcript.status !== 'completed');
        
          return {transcript, item};
        } catch (error) {
           console.info(error)
        }
    })

    const subtitlesArray = await Promise.all(responsedata);

   return (subtitlesArray)

    
};

export { getSubs };